import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ENGAGEMENT_MODELS_DATA } from "config/data";
import { Reveal, StaggerGroup, fadeUp } from "components/ui/motion";

const EngagementModels = () => {
  return (
    <section className="bg-white py-20">
      <div className="container-tt">
        <Reveal className="mx-auto max-w-2xl text-center">
          <span className="eyebrow !text-brand-600 justify-center w-full">
            <span className="h-1.5 w-1.5 rounded-full bg-accent" />
            How we work with you
          </span>
          <h2 className="mt-4 text-3xl font-semibold text-ink sm:text-4xl">Engagement models that fit your stage</h2>
          <p className="mt-4 text-base text-slate-500">
            Whether you need a dedicated team, a fixed scope, or a fast AI MVP — we shape the engagement around
            your goals.
          </p>
        </Reveal>

        <StaggerGroup className="mt-12 grid gap-6 md:grid-cols-3">
          {ENGAGEMENT_MODELS_DATA.map((item, index) => (
            <motion.div
              key={index}
              variants={fadeUp}
              whileHover={{ y: -6 }}
              className="group relative overflow-hidden rounded-2xl border border-slate-100 bg-slate-50 p-8 transition-shadow duration-300 hover:shadow-card"
            >
              <div className="mb-6 h-20 w-20">
                <img src={item.image} className="h-full w-full object-contain" alt="" />
              </div>
              <h3 className="text-xl font-semibold text-ink">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-500">{item.shortDesc}</p>
              <Link
                to="#contact"
                className="mt-5 inline-flex items-center gap-1 text-sm font-semibold text-brand-600 transition-transform group-hover:translate-x-1"
              >
                Learn more →
              </Link>
            </motion.div>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};

export default EngagementModels;
